const SALES_SESSION_KEY = "futuretrade_sales_session_id";
const PAYMENT_ENTRY_SOURCE_KEY = "futuretrade_payment_entry_source";

function createId(prefix) {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `${prefix}_${crypto.randomUUID()}`;
  }

  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function getSalesSessionId() {
  if (typeof window === "undefined") return null;

  try {
    let sessionId = window.sessionStorage.getItem(SALES_SESSION_KEY);
    if (!sessionId) {
      sessionId = createId("session");
      window.sessionStorage.setItem(SALES_SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch {
    return null;
  }
}

export function getDeviceClass(width) {
  const viewportWidth = Number(
    width ?? (typeof window !== "undefined" ? window.innerWidth : 0)
  );

  if (!viewportWidth) return "unknown";
  if (viewportWidth < 600) return "mobile";
  if (viewportWidth < 1024) return "tablet";
  return "desktop";
}

export function buildSalesEventMetadata(metadata = null) {
  const hasWindow = typeof window !== "undefined";
  const viewportWidth = hasWindow ? window.innerWidth : null;
  const viewportHeight = hasWindow ? window.innerHeight : null;

  return {
    schema_version: 2,
    event_id: createId("event"),
    session_id: getSalesSessionId(),
    path: hasWindow ? window.location.pathname : null,
    device_class: getDeviceClass(viewportWidth),
    viewport_width: viewportWidth,
    viewport_height: viewportHeight,
    ...(metadata || {}),
  };
}

export function setPaymentEntrySource(source) {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(PAYMENT_ENTRY_SOURCE_KEY, source);
  } catch {
    // A navegacao continua mesmo quando o storage estiver indisponivel.
  }
}

export function consumePaymentEntrySource() {
  if (typeof window === "undefined") return "subscription_menu";

  try {
    const source = window.sessionStorage.getItem(PAYMENT_ENTRY_SOURCE_KEY);
    window.sessionStorage.removeItem(PAYMENT_ENTRY_SOURCE_KEY);
    return source || "subscription_menu";
  } catch {
    return "subscription_menu";
  }
}

export async function registrarSalesEvent(userId, eventType, options = {}) {
  const token = localStorage.getItem("token");
  if (!token || !userId || !eventType) {
    return null;
  }

  const { source = null, metadata = null, keepalive = false } = options;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/users/${userId}/sales-events`,
      {
        method: "POST",
        keepalive,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          event_type: eventType,
          source,
          metadata: buildSalesEventMetadata(metadata),
        }),
      }
    );

    if (!response.ok) {
      return null;
    }

    return response.json();
  } catch (error) {
    console.warn("Falha ao registrar evento de vendas:", error);
    return null;
  }
}
